export default [
  {
    label: 'label.login',
    name: 'landing-login',
    url: '/',
    navigationIcon: 'far fa-key',
    type: 'item',
  },
  // {
  //   label: 'label.register',
  //   name: 'create-instance-professional-step-one',
  //   url: '/professional/create-instance',
  //   navigationIcon: 'fal fa-handshake',
  //   type: 'item',
  // },
  {
    label: 'label.forgot_password',
    name: 'professional-forgot-password',
    url: '/forgot-password',
    navigationIcon: 'far fa-lightbulb',
    type: 'item',
  },
  // {
  //   label: 'label.more',
  //   name: '',
  //   url: '/more-info',
  //   navigationIcon: 'fal fa-ellipsis-h-alt',
  //   type: 'item',
  // },
];



// WEBPACK FOOTER //
// ./src/data/navigations/public/index.js